import React from 'react';

import Input from '../../../components/Input';

function BooleanFilter({filter, onChange, validations}) {
  return (
    <Input
      type="select"
      value={filter.values[0]}
      onChange={e => onChange({...filter, values: [e.target.value]})}
      invalid={validations.length > 0}
      validationText={validations[0]}>
      <option value="">Choose an option...</option>
      <option value="true">Yes (True)</option>
      <option value="false">No (False)</option>
    </Input>
  );
}

BooleanFilter.validate = filter => {
  if (filter.values[0] !== 'true' && filter.values[0] !== 'false') {
    return ['Please choose Yes (True) or No (False)'];
  }

  return [];
};

BooleanFilter.operators = [
  'EQUAL'
];

export default BooleanFilter;